import React, { useEffect } from 'react';
import { Form, Button, DatePicker, InputNumber } from 'antd';
import { formatDate, getDisabledDates } from 'utils';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import dayjs from 'dayjs';

function BonusForm({ initialValues, disableDate, onSubmit, children }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      const { worker_id, payment_date, amount } = initialValues;

      form.setFieldsValue({
        worker_id,
        payment_date: dayjs(payment_date),
        amount,
      });
    }
  }, [initialValues]);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      payment_date: formatDate(values?.payment_date, 'YYYY-MM-DD'),
    };

    const isSubmitted = await onSubmit(payload);

    if (isSubmitted) {
      form.resetFields();
    }
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
    >
      {children}

      <Form.Item name="payment_date" label="Дата" rules={[requiredRule]}>
        <DatePicker
          format="DD.MM.YYYY"
          allowClear
          disabledDate={getDisabledDates(disableDate)}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name="amount" label="Сумма премии" rules={[requiredRule]}>
        <InputNumber
          addonAfter="KZT"
          controls={false}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }
          placeholder="Введите сумму"
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit">
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
}

export { BonusForm };
